class PagingModel {
}

class SearchFilterGroupData {
    constructor() {
        this.filterGroups = [];
        this.fieldFilters = [];
    }
}

class BaseModel {
    constructor() {
        this.searchFilters = new SearchFilterGroupData();
        this.paging = new PagingModel();
        this.sortList = [];
        this.resultList = [];
    }
}

class BusinessObject {
}

class Contact {
}

class DefaultCustomerLocation {
}

class Screen {
}

class Menu {
    constructor() {
        this.screen = new Screen();
        this.menuList = [];
    }
}

class Permission {
    constructor() {
        this.businessObject = new BusinessObject();
        this.canCreate = false;
        this.canRead = false;
        this.canUpdate = false;
        this.canDelete = false;
        this.canRun = false;
    }
}

class Role {
}

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class SearchFilter {
}
var AndOrOperator;
(function (AndOrOperator) {
    AndOrOperator["and"] = "AND";
    AndOrOperator["or"] = "OR";
})(AndOrOperator || (AndOrOperator = {}));
/**
 * The filter operator (comparison).
 *
 * The supported operators are:
 *
 * * `"eq"` (equal to)
 * * `"neq"` (not equal to)
 * * `"isnull"` (is equal to null)
 * * `"isnotnull"` (is not equal to null)
 * * `"lt"` (less than)
 * * `"lte"` (less than or equal to)
 * * `"gt"` (greater than)
 * * `"gte"` (greater than or equal to)
 *
 * The following operators are supported for string fields only:
 *
 * * `"startswith"`
 * * `"endswith"`
 * * `"contains"`
 * * `"doesnotcontain"`
 * * `"isempty"`
 * * `"isnotempty"`
 */
var FilterOperator;
(function (FilterOperator) {
    FilterOperator["contains"] = "contains";
    FilterOperator["doesnotcontain"] = "doesnotcontain";
    FilterOperator["endswith"] = "endswith";
    FilterOperator["isempty"] = "isnull";
    FilterOperator["isnotempty"] = "isnotnull";
    FilterOperator["eq"] = "eqcaseinsensitive";
    FilterOperator["neq"] = "neq";
    FilterOperator["startswith"] = "startswithcaseinsensitive";
    FilterOperator["gt"] = "gt";
    FilterOperator["lt"] = "lt";
    FilterOperator["lte"] = "lte";
    FilterOperator["gte"] = "gte";
    FilterOperator["isnull"] = "isnull";
    FilterOperator["isnotnull"] = "isnotnull";
})(FilterOperator || (FilterOperator = {}));

class SortModel {
}

class User {
    constructor() {
        this.contact = new Contact();
        this.menuList = [];
        this.roleList = [];
        this.permissionList = [];
        this.siteCodes = [];
    }
}

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class SavedSearch {
    constructor() {
        this.filters = [];
    }
}

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class BaseData {
    constructor() {
        this.disabled = false;
    }
}

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class UserData extends BaseData {
}

class SearchFilterData {
    constructor() {
        this.filterValueList = [];
    }
}

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class FabSavedSearch {
    constructor() {
        this.filters = [];
    }
}

class FabSearchFilter {
}

/*
 *  Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 *  This information is confidential and proprietary to GM Global Technology
 *  Operations LLC and may not be used, modified, copied or distributed
 */
class errorData {
}
class keepAliveData {
}
class ResponseModel extends BaseModel {
}

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AndOrOperator, BaseData, BaseModel, BusinessObject, Contact, DefaultCustomerLocation, FabSavedSearch, FabSearchFilter, FilterOperator, Menu, PagingModel, Permission, ResponseModel, Role, SavedSearch, Screen, SearchFilter, SearchFilterData, SearchFilterGroupData, SortModel, User, UserData, errorData, keepAliveData };
